import { TabLoading } from '@features/regional-overview/digital-traps/components/tab-loading/tab-loading.component';
import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import { FLIGHT_CURVE_TAB } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { useTranslation } from 'react-i18next';
import { FlightCurveContainer } from './flight-curve.styles';
import Graph from './graph';
import Sidebar from './sidebar';

const FlightCurve = () => {
  const [t] = useTranslation();
  const isLoading = useDigitalTrapsStore(state => state.isLoading);

  if (isLoading) {
    return <TabLoading text={t('pages.regional_overview.digital_traps.flight_curve.loading_text')} />;
  }

  return (
    <FlightCurveContainer data-testid={FLIGHT_CURVE_TAB}>
      <Sidebar />
      <Graph />
    </FlightCurveContainer>
  );
};

export default FlightCurve;
